import styled from 'styled-components';

const PopconfirmStyled = component => styled(component)`
  
`;

export default PopconfirmStyled;
